import React, { Component } from 'react'

import withProducts from 'containers/withProducts'
import withTranslations from 'containers/withTranslations'
import { withRouter } from 'react-router'
import { compose } from 'react-apollo'

import styled from 'styled-components'
import theme from 'ui/styles/theme'
import easing from 'ui/styles/easing'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'

import Product from './Product'
import IconCapacitive from './IconCapacitive'
import IconClimate from './IconClimate'
import IconManagement from './IconManagement'

//line comments are for when we have also management sensors (3 options)

const StyledContainer = styled(Container)`
  padding-left: 0 !important;
  padding-right: 0 !important;

  ${media.sm`
    padding-left: ${theme.grid.container.padding}px !important;
    padding-right: ${theme.grid.container.padding}px !important;
  `}
`

const FilterWrapper = styled.div`
  background: ${theme.colors.primary};
`

const FilterTextContainer = styled.div`
  margin: 32px 20px 0;

  ${media.sm`
    margin: 32px 32px 0;
  `}
`

const FilterText = styled.p`
  border-top: 1px solid white;
  display: block;
  color: white;
  text-transform: uppercase;
  padding-top: 32px;
  margin: 0;
`

const FilterContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  // padding: 50px 20px;
  padding: 50px 0px;

  ${media.sm`
  justify-content: space-around;
  `}
`

const ButtonName = styled.p`
align-self: center;
`

const Filter = styled.button`
  background-color: ${props => props.active ? 'white' : theme.colors.accents.primary};
  color: ${props => props.active ? theme.colors.primary : theme.colors.secondary};
  flex-grow: 0;
  border: none;
  padding: 20px 10px 28px;
  display: flex;
  transition: color 0.3s ${easing.easeOutCubic}, background-color 0.3s ${easing.easeOutCubic};
  outline: none;
  width: 44%;
  flex-wrap: wrap;
  text-align: center;
  overflow: hidden;
  justify-content: center;
  font-size: 10px;
  flex-direction: column;
  align-content: center;

  p {
    margin: 0;
  }

  ${media.sm`
    font-size: 20px;
    padding: 20px 28px 28px;
    // margin: 0 18px;
    margin: 0 0px;
    justify-content: flex-start;
    width: 48%;
    // flex-grow: 1;
    flex-direction: row;
    align-content: flex-start;
  `}

  &:hover {
    background-color: white;
    color: ${theme.colors.primary};
  }
`

const Icon = styled.div`
  margin-bottom: 20px;


  ${media.sm`
    margin-right: 20px;
    margin-bottom: 0;
  `}
`

const ProductWrapper = styled.div`
  padding: 80px 0;
`
const RowExtended = styled(Row)`
  margin: 0px;
`

class Products extends Component {
  constructor(props) {
    super(props)

    this.setHover = this.setHover.bind(this)
    this.setFilter = this.setFilter.bind(this)
  }

  state = {
    hover: null,
    filter: null,
    finishedSorting: false
  }

  setHover(filter) {
    this.setState({ hover: filter })
  }

  setFilter(filter) {
    if (filter === this.state.filter) {
      this.setState({ filter: null })
    } else {
      this.setState({ filter })
    }
  }

  getProducts() {
    const filter = this.state.filter
    const filteredList = this.props.products.filter(product =>
      filter ? product.type === filter : true
    )

    filteredList.sort((a, b) => {
      return a.menuOrder - b.menuOrder
    })

    return filteredList
  }

  render() {
    const products = this.getProducts()
    const { text, translations } = this.props

    return (
      <StyledContainer fluid>
        <FilterWrapper>
          <RowExtended>
            <Col
              sm={10}
              smOffset={1}
            >
              {text &&
                <FilterTextContainer>
                  <FilterText>{text}</FilterText>
                </FilterTextContainer>
              }
              <FilterContainer>
                <Filter
                  onMouseEnter={e => this.setHover('capacitive')}
                  onMouseLeave={e => this.setHover(null)}
                  onClick={e => this.setFilter('capacitive')}
                  active={this.state.filter === 'capacitive'}
                >
                  <Icon>
                    <IconCapacitive
                      active={this.state.filter === 'capacitive'}
                      hover={this.state.hover === 'capacitive'}
                    />
                  </Icon>
                  <ButtonName>{translations && translations.productTypes.capacitive}</ButtonName>
                </Filter>
                <Filter
                  onMouseEnter={e => this.setHover('climate')}
                  onMouseLeave={e => this.setHover(null)}
                  onClick={e => this.setFilter('climate')}
                  active={this.state.filter === 'climate'}
                >
                  <Icon>
                    <IconClimate
                      active={this.state.filter === 'climate'}
                      hover={this.state.hover === 'climate'}
                    />
                  </Icon>
                  <ButtonName>{translations && translations.productTypes.climate}</ButtonName>
                </Filter>

                {/*    Filter for management sensors             <Filter
                  onMouseEnter={e => this.setHover('management')}
                  onMouseLeave={e => this.setHover(null)}
                  onClick={e => this.setFilter('management')}
                  active={this.state.filter === 'management'}
                  >
                  <Icon>
                    <IconManagement
                      active={this.state.filter === 'management'}
                      hover={this.state.hover === 'management'}
                    />
                  </Icon>
                  <p>{translations && translations.productTypes.management}</p>
                </Filter> */}
              </FilterContainer>
            </Col>
          </RowExtended>
        </FilterWrapper>
        <ProductWrapper>
          <RowExtended>
            <Col
              sm={10}
              smOffset={1}
            >
              <RowExtended>
                {products.map(product => {
                  return (
                    <Col sm={6} key={product.id}>
                      <Product
                        video={product.video ? product.video.sourceUrl : null}
                        image={product.image ? product.image.sourceUrl : null}
                        title={product.title}
                        link={product.link}
                      />
                    </Col>
                  )
                })}
              </RowExtended>
            </Col>
          </RowExtended>
        </ProductWrapper>
      </StyledContainer>
    )
  }
}

export default compose(
  withRouter,
  withTranslations(),
  withProducts()
)(Products)



// WEBPACK FOOTER //
// ./src/ui/components/modules/Products/index.js